import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/Home';
import Institucional from './pages/Institucional';
import Congreso from './pages/Congreso';
import DetalleCongreso from './pages/DetalleCongreso'; 
import Biblioteca from './pages/Biblioteca';
import Noticias from './pages/Noticias';
import Contacto from './pages/Contacto';
import AdminLogin from './pages/AdminLogin'; 
import AdminPanel from './pages/AdminPanel'; 
import NoticiaDetalle from './pages/NoticiaDetalle'; 
import EstudiosDeMercado from './pages/EstudiosDeMercado';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/*" element={<MainLayout />} />
        <Route path="/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminPanel />} />
        
      </Routes>
    </Router>
  );
}

const MainLayout = () => (
  <>
    <Navigation />
    <main>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/institucional/:section?" element={<Institucional />} />
        <Route path="/congreso" element={<Congreso />} />
        <Route path="/congreso/:congresoId" element={<DetalleCongreso />} />
        <Route path="/biblioteca" element={<Biblioteca />} />
        <Route path="/noticias" element={<Noticias />} />
         <Route path="/noticia/:noticiaId" element={<NoticiaDetalle />} />
        <Route path="/contacto" element={<Contacto />} />
         <Route path="/estudios-de-mercado" element={<EstudiosDeMercado />} />
      </Routes>
    </main>
    <Footer />
  </>
);

export default App;